import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  SubscriptionID: null,
  SubscriptionPlanID: null,
  SubscriptionPlanCode: null,
  SubscriptionPlanName: null,
  SubscriptionState: null,
  SubscriptionCurrentPeriodEndsAt: null,
  SubscriptionTrialEndsAt: null,
  SubscriptionAutoRenew: null,
  SubscriptionPausedAt: null,
  SubscriptionRemainingPauseCycles: null,
  SubscriptionCurrency: null,
  SubscriptionUnitPrice: null,
  SubscriptionExpiresAt: null,
  PlanDescription: null,
  PlanInterval: null,
  PlanIntervalLength: null,
  PlanFreeTrialInterval: null,
  PlanFreeTrialLength: null,
  PendingChangeId: null,
  PendingChangeNewPlanId: null,
  PendingChangeNewPlanCode: null,
  PendingChangeNewPlanName: null,
  PendingChangeNewUnitPrice: null,
  PendingChangeEffectiveDate: null,
  NextChargePlanName: null,
  NextChargeAmount: null,
  NextChargeDate: null,
  LINKtivityAccessAllowed: false,
  Loaded: false,
};

export const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setSubscription: (state, action) => {
      state.SubscriptionID = action.payload.SubscriptionID;
      state.SubscriptionPlanID = action.payload.SubscriptionPlanID;
      state.SubscriptionPlanCode = action.payload.SubscriptionPlanCode;
      state.SubscriptionPlanName = action.payload.SubscriptionPlanName;
      state.SubscriptionState = action.payload.SubscriptionState;
      state.SubscriptionCurrentPeriodEndsAt =
        action.payload.SubscriptionCurrentPeriodEndsAt;
      state.SubscriptionTrialEndsAt = action.payload.SubscriptionTrialEndsAt;
      state.SubscriptionAutoRenew = action.payload.SubscriptionAutoRenew;
      state.SubscriptionPausedAt = action.payload.SubscriptionPausedAt;
      state.SubscriptionRemainingPauseCycles =
        action.payload.SubscriptionRemainingPauseCycles;
      state.SubscriptionCurrency = action.payload.SubscriptionCurrency;
      state.SubscriptionUnitPrice = action.payload.SubscriptionUnitPrice;
      state.SubscriptionExpiresAt = action.payload.SubscriptionExpiresAt;
      state.PlanDescription = action.payload.PlanDescription;
      state.PlanInterval = action.payload.PlanInterval;
      state.PlanIntervalLength = action.payload.PlanIntervalLength;
      state.PlanFreeTrialInterval = action.payload.PlanFreeTrialInterval;
      state.PlanFreeTrialLength = action.payload.PlanFreeTrialLength;
      state.PendingChangeId = action.payload.PendingChangeId;
      state.PendingChangeNewPlanId = action.payload.PendingChangeNewPlanId;
      state.PendingChangeNewPlanCode = action.payload.PendingChangeNewPlanCode;
      state.PendingChangeNewPlanName = action.payload.PendingChangeNewPlanName;
      state.PendingChangeNewUnitPrice =
        action.payload.PendingChangeNewUnitPrice;
      state.PendingChangeEffectiveDate =
        action.payload.PendingChangeEffectiveDate;
      state.NextChargePlanName = action.payload.NextChargePlanName;
      state.NextChargeAmount = action.payload.NextChargeAmount;
      state.NextChargeDate = action.payload.NextChargeDate;
      if (
        action.payload.SubscriptionState === 'active' ||
        action.payload.SubscriptionState === 'canceled'
      ) {
        state.LINKtivityAccessAllowed = true;
      } else {
        state.LINKtivityAccessAllowed = false;
      }
      state.Loaded = true;
    },
    resetSubscription: () => initialState,
    setSubscriptionLoaded: (state, action) => {
      state.Loaded = action.payload;
    },
  },
});

export const { setSubscription, resetSubscription, setSubscriptionLoaded } =
  subscriptionSlice.actions;

export default subscriptionSlice.reducer;

// Selectors
export const selectSubscription = (state) => state.subscription;
export const selectSubscriptionLoaded = (state) => state.subscription.Loaded;
export const selectLINKtivityAccessAllowed = (state) =>
  state.subscription.LINKtivityAccessAllowed;
